module.exports = __webpack_public_path__ + "img/res05.7bfd94fd.png";